export const TEST = 'TEST';

export const test = text => ({
    type: TEST,
    payload: text,
});

